// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const FORMAT_COLUMNS_STEP_SHAPES = [
  {
    stepType: PipelineStepType.FORMAT_COLUMNS,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      formatColumns: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            column: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              allowMissingColumn: false,
              validationOptions: {
                allowedLeafTypes: [
                  LeafType.INTEGER,
                  LeafType.DECIMAL
                ]
              }
            },
            format: {
              kind: 'taggedUnion',
              required: true,
              tagKey: 'type',
              choices: [
                {
                  kind: 'shape',
                  required: true,
                  fields: {
                    type: {
                      kind: 'string',
                      required: true,
                      value: 'NUMERIC'
                    },
                    precision: {
                      kind: 'integer',
                      required: true,
                      minValue: 0,
                      maxValue: 20
                    }
                  }
                }
              ]
            }
          }
        },
        minItems: 1
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
